import React from 'react';
import TransformationLibClusterSelect from './TransformationLibClusterSelect';
import { Grid } from '@metarouter-private/mr-mui';
import TransformationLibNameFilter from './TransformationLibNameFilter';

function TransformationLibTableHeader() {
  return (
    <Grid container alignItems="center" flexWrap="nowrap" spacing={2}>
      <Grid item xs={4}>
        <TransformationLibClusterSelect />
      </Grid>
      <Grid item flexGrow={1}>
        <TransformationLibNameFilter />
      </Grid>
    </Grid>
  );
}

export default TransformationLibTableHeader;
